// Mirrors backend/services/credit_calculation.go's pricingTable (matched via string.includes,
// most specific first, first match wins). Keep both in sync when rates change.
//
// Kept separate from models.ts (and pattern-matched rather than keyed by exact model id) so the
// two tables stay structurally identical and easy to diff, and so patterns like 'claude'/'gpt'
// can act as catch-alls covering every vendor/route variant of a model without a factor having
// to be repeated on (or forgotten for) each individual models.ts entry.
const pricingTable: [pattern: string, factor: number][] = [
	// Anthropic / Bedrock
	['opus-4', 3.0],
	['opus-5', 3.0],
	['fable-5', 6.0],
	['sonnet-5', 1.0],
	['sonnet-4', 1.0],
	['haiku-4', 0.5],
	['haiku-5', 0.33],
	['claude', 1.0],

	// Mistral
	['magistral-medium', 1.0],
	['mistral-large-4', 0.5],
	['mistral-large', 0.5],
	['magistral-small', 0.5],
	['mistral-medium', 0.75],
	['mistral-small', 0.33],

	// Scaleway open models
	['qwen3.5-397b', 0.33],
	['qwen3.6', 0.33],
	['qwen3.8', 0.33],
	['qwen3-235b', 0.33],
	['llama-3.3-70b', 0.33],
	['holo2-30b', 0.33],
	['gemma-4', 0.33],
	['gemma-3-27b', 0.33],
	['gpt-oss-120b', 0.33],
	['deepseek-v4.1-flash', 0.33],
	['deepseek-v4-flash', 0.33],
	['glm-5.3', 0.75],
	['glm-5.2', 0.75],

	// OpenAI
	['gpt-6.1-sol', 1.0],
	['gpt-6-luna', 0.33],
	['gpt-5-mini', 0.33],
	['gpt-5.4', 1.0],
	['o3', 0.75],
	['o4-mini', 0.5],
	['gpt', 0.75]
];

const DEFAULT_FACTOR = 1.0;

export function getModelCreditFactor(model: string): number {
	return pricingTable.find(([pattern]) => model.includes(pattern))?.[1] ?? DEFAULT_FACTOR;
}

export function formatCreditFactor(factor: number): string {
	return `${factor % 1 === 0 ? factor.toFixed(0) : factor}×`;
}
